import { createSlice } from "@reduxjs/toolkit";

const selectedFieldSlice = createSlice({
  name: "selectedField",
  initialState: {
    field: null,
    crop: null,
  },
  reducers: {
    setField(state, action) {
      state.field = action.payload;
    },
    setCrop(state, action) {
      state.crop = action.payload;
    },
    clearField(state) {
      state.field = null;
      state.crop = null;
    },
  },
});

export const { setField, clearField, setCrop } = selectedFieldSlice.actions;
export default selectedFieldSlice.reducer;